import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import Modal from '../../../realize_overrides/components/modal/modal.jsx';
import { ModalActions } from '../../../realize_overrides/stores/modal_store';
import ScreenSizes from '../../../screen_sizes';
import { GridFormActions } from '../../reflux/grid_form_store';

const Realize = {
	Modal: Modal,
	ModalHeader: window.ModalHeader,
	ModalContent: window.ModalContent,
	ModalFooter: window.ModalFooter,
	CssClassMixin: window.CssClassMixin
};

@mixin.decorate(Realize.CssClassMixin)

export default class InputGridFormFieldsModal extends React.Component {
	static propTypes = {
		id: PropTypes.string,
		inputs: PropTypes.object,
		data: PropTypes.object,
		errors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		resource: PropTypes.string,
		disabled: PropTypes.bool,
		readOnly: PropTypes.bool,
		okButton: PropTypes.object,
		closeButton: PropTypes.object,
		formAction: PropTypes.string,
		label: PropTypes.string,
		createModalLabel: PropTypes.string,
		editModalLabel: PropTypes.string,
		onFormSubmit: PropTypes.func
	};

	static defaultProps = {
		id: '',
		inputs: {},
		data: {},
		errors: {},
		disabled: false,
		readOnly: false,
		okButton: {
			name: 'OK',
			icon: 'send'
		},
		closeButton: {
			name: 'Cancelar',
			style: 'cancel',
			icon: 'clear'
		},
		formAction: 'create',
		label: null,
		createModalLabel: null,
		editModalLabel: null,
		onFormSubmit: (event, fieldsData) => {},
		onFormReset: (event) => {}
	};

	state = {
		submitOnClose: false
	};

	constructor(props) {
		super(props);

		this.handleOkButtonClick = this.handleOkButtonClick.bind(this);
		this.handleCloseButtonClick= this.handleCloseButtonClick.bind(this);
	}

	setModalContentHeight(modalComponent, defaultResizer) {
		let modalRef = modalComponent.refs.modal;
		if(!this.props.isMobile && window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH) {
			defaultResizer();
		}
		else {
			let $modalNode = $(ReactDOM.findDOMNode(modalRef));
			let height = window.innerHeight - 16;

			$modalNode.css('max-height', height);
			$modalNode.css('height', height);
		}
	}

	getModalId() {
		return this.props.id + '-modal';
	}

	// Event handlers

	handleCloseButtonClick(event) {
		const cloneEvents = $.extend(true, {}, event);
		ModalActions.close({ modalId: this.getModalId() }, this.resetFormFields.bind(this, cloneEvents));
	}

	handleOkButtonClick(event) {
		const cloneEvents = $.extend(true, {}, event);
		ModalActions.close({ modalId: this.getModalId() }, this.submitFormFields.bind(this, cloneEvents));
	}

	resetFormFields(event) {
		GridFormActions.reset(this.props.id);
	}

	submitFormFields(event) {
		GridFormActions.submitDataRow(this.props.id);
	}

	// Renderers

	render() {
		return (
			<Realize.Modal
				typeModal={"GRID"}
				minContentHeight={600}
				resizer={this.setModalContentHeight}
				id={this.getModalId()}
				ref="modal"
				isMobile={this.props.isMobile}>
				{this.renderHeader()}
				{this.renderContent()}
				{this.renderFooter()}
			</Realize.Modal>
		);
	}

	renderHeader() {
		return (
			<Realize.ModalHeader key="modal-header">
				<h5 tabIndex="0">{this.getHeaderTitle()}</h5>
			</Realize.ModalHeader>
		);
	}

	renderContent() {
		return (
			<Realize.ModalContent>
				{this.props.inputs}
			</Realize.ModalContent>
		);
	}

	renderFooter () {
		return (
			<Realize.ModalFooter className={'right-align'}>
				<ButtonGroup
					buttons={[this.getCloseButtonProps(), this.getOkButtonProps()]}
				/>
			</Realize.ModalFooter>
		);
	}

	// Props handlers

	getOkButtonProps() {
		return Object.assign({}, this.props.okButton, {
			element: 'button',
			onClick: this.handleOkButtonClick
		});
	}

	getCloseButtonProps() {
		return Object.assign({}, this.props.closeButton, {
			element: 'button',
			onClick: this.handleCloseButtonClick
		});
	}

	getHeaderTitle() {
		let formAction = this.props.formAction;

		switch(formAction) {
			case 'update':
				return this.props.editModalLabel || `Editar ${this.props.label}`;
			case 'create':
			default:
				return this.props.createModalLabel || `Criar ${this.props.label}`;
		}
	}
}
